<template>
  <div  class="tournaments-sidebar">
    <a href="#" @click.prevent="router.push({name: 'home'})" class="nav-back">
      <svg-icon icon="back"/> <span>{{$t('back_to_lobby')}}</span>
    </a>
    <div class="header-slider" :ref="(el: any) => sliderRef = el">
      <TournamentCard v-for="(item, index) in activeTournaments" :item="item"  :key="item.id" class="header-slider__item"></TournamentCard>
    </div>
    <TournamentContent class="sidebar" :tournament="selectedTournament"/>
  </div>
</template>

<style scoped>
.nav-back {
  display: flex;
  gap: var(--margin-xs);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5%;
  align-items: center;
  color: #FFFFFFA3;
  text-decoration: none;
  margin: 0 var(--margin-normal) var(--margin-sm);
}
</style>

<script setup lang="ts">
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import TournamentDTO from "@/models/TournamentDTO";
import {TournamentStatus} from "@/models/enum/TournamentStatus";
import TournamentContent from "@/components/TournamentContent.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import {$t} from "@/i18n";

const store = useStore()
const router = useRouter()

const sliderRef = ref<InstanceType<typeof HTMLElement> | null>(null)
const activeIndex = ref(0)

const selectedTournament = computed(() => {
  return store.getters.liveTournaments[activeIndex.value]
})

const activeTournaments = computed(() => {
  return store.getters.liveTournaments.filter((item: TournamentDTO) => item.status === TournamentStatus.ACTIVE)
})


onMounted(() => {
  activeIndex.value = 0
  sliderRef.value?.addEventListener('scroll', () => {
    const el = sliderRef.value!
    const itemWidth = el.firstElementChild!.clientWidth + 16
    activeIndex.value = Math.round(el.scrollLeft / itemWidth)
  }, { passive: true })
})


</script>